// extracted by mini-css-extract-plugin
export default {"table":"MyTable_table__SWEN4","lastRow":"MyTable_lastRow__C6CRL"};